export interface AccountTrade {
  ConnectionId: string;
  ChasWorkCode: string;
  TradeName: string;
  PrimaryTradeName: string;
}
